<template>
  <div class="list-group-header">
    <div class="left">
      <!-- 'Main' content (title, subtitle) -->
      <!-- Should use ListHeaderContent components -->
      <slot />
    </div>
    <div v-if="$slots.after" class="right">
      <slot name="after" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/font";
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";

.list-group-header {
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
  gap: 12px;
  padding: 8px 16px;
  flex-grow: 1;

  .left {
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
    gap: 6px;
  }

  .right {
    @include typography.small("semi-bold");

    text-align: right;
    color: colors.$text-subtle;
  }
}
</style>
